/**
 * Store Utilities — reusable helpers for Zustand stores
 * Used by all entity stores for consistent CRUD operations.
 */

export const storeUtils = {
    /** Thêm item vào đầu mảng */
    append: <T>(array: T[], item: T): T[] => [item, ...array],

    /** Lọc bỏ items theo predicate */
    filter: <T>(array: T[], predicate: (item: T) => boolean): T[] =>
        array.filter(predicate),

    /** Map / cập nhật items theo mapper */
    map: <T>(array: T[], mapper: (item: T) => T): T[] => array.map(mapper),

    /** Tìm item theo predicate */
    find: <T>(array: T[], predicate: (item: T) => boolean): T | undefined =>
        array.find(predicate),
};
